/**
 * TICTAC 2 GO — scroll reveal
 * Reveals any element with [data-reveal] when it enters the viewport.
 * Respects prefers-reduced-motion and re-observes new nodes added after
 * initial load (Shopify section re-renders in the theme editor).
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasObserver = typeof IntersectionObserver !== 'undefined';

  if (prefersReducedMotion || !hasObserver) {
    document.querySelectorAll('[data-reveal]').forEach(function (node) {
      node.classList.add('is-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
  );

  function observeAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (node) {
      var delay = Number(node.getAttribute('data-reveal-delay') || 0);
      node.style.setProperty('--reveal-delay', delay + 'ms');
      observer.observe(node);
    });
  }

  observeAll();

  /* Safety net.
     IntersectionObserver callbacks are not delivered to hidden/background
     documents, and some embedded/preview contexts never fire them at all —
     which would leave whole sections stuck at opacity:0. This manual pass
     reveals anything that is actually on screen, so content can never be
     invisible to a real visitor. The observer still drives the normal
     staggered animation when it works. */
  function revealOnScreen() {
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (node) {
      var rect = node.getBoundingClientRect();
      // `innerHeight` is 0 in hidden/embedded documents, which would make a
      // viewport test reject everything — so only skip what is clearly below.
      var limit = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!limit || (rect.top < limit * 0.9 && rect.bottom > 0)) {
        node.classList.add('is-revealed');
      }
    });
  }

  function revealEverything() {
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (node) {
      node.classList.add('is-revealed');
    });
  }

  /* Throttled: at most one pass per 400ms, and only while something is still
     unrevealed. The observer does the real work; this only catches contexts
     where it never fires. */
  var lastPass = 0;
  var onScroll = function () {
    var now = Date.now();
    if (now - lastPass < 400) return;
    /* Nothing left to reveal: stop paying for this query on every scroll event. */
    if (!document.querySelector('[data-reveal]:not(.is-revealed)')) { window.removeEventListener('scroll', onScroll); return; }
    lastPass = now; revealOnScreen();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', revealOnScreen);
  window.addEventListener('load', revealOnScreen);
  setTimeout(revealOnScreen, 1200);
  // Last resort: content must never be left invisible, whatever the context.
  setTimeout(revealEverything, 2500);

  // Re-scan when Shopify re-renders sections in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
    window.addEventListener('scroll', onScroll, { passive: true }); // re-arm the safety net for the new nodes
    revealOnScreen();
  });
})();
